import { pipe } from 'fp-ts/lib/function';
import {
  createAuthorizedPostRequest,
  fetchApi, setBody,
} from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';

const baseUrl = '/v2/integrations/alert-monitors';
export const create = (instanceId: string) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody({ instance_id: instanceId })),
  chain(fetchApi),
);
